import React from "react";
import solar from "../assets/solar-panel.jpg";
import office from "../assets/workplace.jpg";
import bgImage from "../assets/factory.jpg";

const ServicesSection = () => {
  const products = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-12 h-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
      title: "Full & Bificial Panels",
      description:
        "585 KW and above Panels are ideal for large, open spaces, maximizing solar energy capture. Bificial panels increases efficiency by 20%.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-12 h-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
      ),
      title: "Half Sized Panels",
      description:
        "410kW for areas with limited access or requiring lighter panels. Ideal for roofs with space or weight constraints.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-12 h-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      title: "Custom Sized Panels",
      description:
        "For unique projects tailored to fit irregular roofs or specific installation needs.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-12 h-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      title: "Turn-key Solar Panel System",
      description:
        "From site assessment and system design to installation and maintenance, we handle every step to ensure a seamless transition to lower your energy cost.",
    },
  ];

  return (
    <section className="relative bg-gradient-to-b from-white to-gray-50 py-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={bgImage}
          alt="Factory Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-50"></div>{" "}
        {/* Blue translucent overlay */}
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        {/* Images Section */}
        <div className="grid md:grid-cols-2 gap-8 mb-20">
          <div className="relative group">
            <img
              src={office}
              alt="Office Generator"
              className="w-full h-72 object-cover rounded-2xl shadow-lg transition-transform duration-300 group-hover:scale-[1.02]"
            />
          </div>
          <div className="group">
            <img
              src={solar}
              alt="Solar Panel"
              className="w-full h-72 object-cover rounded-2xl shadow-lg transition-transform duration-300 group-hover:scale-[1.02]"
            />
          </div>
        </div>
        {/* Services Card */}
        <div className="bg-white p-6 md:p-10 pb-8 md:pb-12 rounded-2xl shadow-lg mb-10 md:mb-20" id="services">
          {/* Header */}
          <div className="max-w-4xl mb-8 md:mb-12 mx-auto text-center">
            <p className="text-orange-500 text-lg md:text-2xl font-bold tracking-wide mb-4 md:mb-6">
              ACCELERATE MYANMAR'S SHIFT FROM DIESEL-POWERED ENERGY TO SOLAR
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-blue-900 leading-tight">
              We Provide Solutions<br />
              <span className="text-blue-900">To Your Energy Needs</span>
            </h2>
          </div>

          {/* Services Content */}
          <div className="max-w-4xl mx-auto space-y-8 md:space-y-16">
            {/* Service Cards */}
            <div className="space-y-8 md:space-y-16">
              {/* Service cards content */}
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div className="text-center">
          {/* Efficiency Tags */}
          <div className="inline-flex flex-wrap items-center justify-center gap-2 md:gap-4 text-orange-500 font-medium tracking-wide mb-4 md:mb-8 bg-orange-50 px-2 py-1 md:px-4 md:py-2 rounded-full break-words text-center">
            <span>HIGH EFFICIENCY</span>
            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
            <span>DURABLE</span>
            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
            <span>FLEXIBLE</span>
          </div>
          <div className="bg-white p-6 md:p-10 rounded-2xl shadow-lg">
            <h3 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              Our Products & Services
            </h3>
            <p className="text-xl md:text-3xl text-orange-500 font-medium mb-8 md:mb-12">
              Meet standards of <strong>IEC 61215 & 61730</strong>
            </p>
            <div className="relative max-w-7xl mx-auto px-4 py-10 md:py-20">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                {products.map((product, index) => (
                  <div key={index} className="flex gap-4 md:gap-6">
                    {/* Icon Container */}
                    <div className="bg-orange-500 p-4 rounded-xl flex items-center">
                      <div className="text-white">{product.icon}</div>
                    </div>

                    {/* Text Content */}
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-2 md:mb-4 text-left">
                        {product.title}
                      </h3>
                      <p className="text-base md:text-xl leading-relaxed text-left">
                        {product.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;